import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Button,
  Flex,
} from "@chakra-ui/react";
import { FC, useRef } from "react";
import { ModalConfig } from "../../../types/Components/Modal/ModalConfig";
import IndicatorDetails from "./IndicatorDetails";

interface ModalIndicatorDetailsOnlyProps {
  control: any;
  modalConfig: ModalConfig;
}

const ModalIndicatorDetailsOnly: FC<ModalIndicatorDetailsOnlyProps> = ({
  control,
  modalConfig,
}) => {
  const { isOpen, title = "", buttonTitle, closeModal } = modalConfig;
  const modalRef = useRef<HTMLDivElement>(null);

  return (
    <Modal isOpen={isOpen} onClose={closeModal} isCentered size="4xl">
      <ModalOverlay />
      <ModalContent
        ref={modalRef}
        boxShadow="none"
        border="none"
        overflow="hidden"
      >
        <ModalHeader fontSize="xl" fontWeight="bold">
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="4">
          <IndicatorDetails indicator={control._formValues.row} />
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="space-between" width="100%">
            <Button onClick={closeModal}>{buttonTitle}</Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalIndicatorDetailsOnly;
